module.exports = ".mat-card-content {\n  font-size: 17px;\n  margin-right: 24px;\n  margin-left: 24px; }\n\n.delete-dialog {\n  width: 580px; }\n"